"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : GRID : STYLES --------------- ++++++++++ */


var _default = {
  grid: {
    extend: [_index.classStyleHelper.direction],
    // ----- direction ----- //
    '& .gridset': {
      '&.direction-horizontal': {
        flexDirection: 'row'
      },
      '&.direction-vertical': {
        flexDirection: 'column',
        '& .griditem': {
          marginRight: '0 !important'
        }
      }
    }
  }
};
exports.default = _default;